import { create } from '@patsnap/tahiti-core';

export const i18nDeferred = create<void>();
